import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Divider, HoverStyles, Text, TextButton} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useAppActions} from '../../../../hooks/runtime'
import {RegistrationUnavailableInfoProps} from './interfaces'
import {classes} from './registration-unavailable-info.st.css'

export const RegistrationUnavailableInfo: React.FC<RegistrationUnavailableInfoProps> = ({
  config: {messages, dataHook, customLabel, href, onClick},
  className,
}) => {
  const {isPreview, isMobile: mobile} = useEnvironment()
  const {navigateToMainPage} = useAppActions()

  const handleClick = () => (isPreview && !onClick ? navigateToMainPage() : onClick())

  return (
    <div className={classNames(className, {[classes.mobile]: mobile})} data-hook={dataHook}>
      <Divider className={classes.divider} />
      <div className={classes.innerContainer}>
        <Text className={classes.text}>{customLabel ?? messages.message}</Text>
        <div>
          <TextButton
            data-hook={DH.RSVP_INFO_BUTTON}
            hoverStyle={HoverStyles.underline}
            className={classes.button}
            href={href}
            as={href ? 'a' : 'button'}
            onClick={href ? null : handleClick}
          >
            {messages.exploreEventsActionLabel}
          </TextButton>
        </div>
      </div>
    </div>
  )
}
